/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import { useStaticAsset } from '@leagueplatform/asset-config';
import {
  Box,
  GDSStyleObject,
  UtilityText,
  StackItem,
  TextAction,
} from '@leagueplatform/genesis-core';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import { getPartnerAccessToken } from '@leagueplatform/sso-util';
import { FORMS_LIBRARY_ASSET_KEYS } from '../../../types/forms-library.types';
import { SuccessModal } from './sucessModal';
import { ConfirmationModal } from './confirmationModal';
import { submitForm } from '../helpers';
import { FORM_API_TYPE } from '../../../types/online-forms.types';
import { formsLibrary } from '../../../forms-library.config';
import { ErrorModal } from './errorModal';

export function FooterMultiStepProgress(props: any) {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const [isSuccessModal, setIsSuccessModal] = useState<boolean>(false);
  const [isErrorModal, setIsErrorModal] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const {
    handleFormOrNext,
    isValidateForm,
    list,
    closeForm,
    formName,
    closeInstructions,
    showNext,
    instructionsList,
    noOcCompList,
    footerToBottom,
  } = props;

  const config = formsLibrary.getConfig();
  const { HIGHMARK_API_URL, useCurrentRegionUbkHeader } = config;
  const currentUbk: any = useCurrentRegionUbkHeader() || null;
  const ubkValue = currentUbk?.headers?.Brandubk || null;

  const leftArrowIcon = useStaticAsset(
    FORMS_LIBRARY_ASSET_KEYS.LEFT_ARROW_ICON,
  );
  const leftArrowDisabledIcon = useStaticAsset(
    FORMS_LIBRARY_ASSET_KEYS.LEFT_ARROW_DISABLED_ICON,
  );
  const rightArrowIcon = useStaticAsset(
    FORMS_LIBRARY_ASSET_KEYS.RIGHT_ARROW_ICON,
  );

  const goNext = () => {
    if (handleFormOrNext) {
      if (selectedIndex !== list.length - 1) {
        setSelectedIndex(selectedIndex + 1);
        isValidateForm(false);
      }
    } else {
      isValidateForm(true);
    }
  };

  const goPrevious = () => {
    if (selectedIndex !== 0) {
      setSelectedIndex(selectedIndex - 1);
    }
    isValidateForm(false);
  };

  // eslint-disable-next-line consistent-return
  async function handleFormSubmit() {
    if (handleFormOrNext) {
      setIsLoading(true);
      const userData = submitForm(formName);
      const token = await getPartnerAccessToken('highmark');

      const url = `${HIGHMARK_API_URL}/digital/v1/members/forms-library/${formName}/submit`;
      const options = {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
          ...(ubkValue && { brandUbk: ubkValue }),
        },
        body: JSON.stringify(userData),
      };

      try {
        const response = await fetch(url, options);
        const data = await response.json();
        setIsLoading(false);
        if (data?.status === '200') {
          setIsSuccessModal(true);
        } else {
          setIsErrorModal(true);
        }
      } catch (error) {
        setIsLoading(false);
        setIsErrorModal(true);
      }
    } else {
      isValidateForm(true);
    }
  }

  return (
    <div data-testid="footer-modal">
      {isLoading ? (
        <LoadingIndicator />
      ) : (
        <>
          {isErrorModal && (
            <ErrorModal onClose={() => setIsErrorModal(false)} />
          )}
          {isSuccessModal ? (
            <SuccessModal onClose={closeForm} formName={formName} />
          ) : (
            <>
              <ConfirmationModal
                onClose={closeForm}
                selectedIndex={selectedIndex}
              />
              <div>
                {formName === FORM_API_TYPE.DENTAL_CLAIM
                  ? showNext
                    ? instructionsList[0]
                    : sessionStorage.getItem('otherCoverage') === 'NO'
                    ? noOcCompList[selectedIndex]
                    : list[selectedIndex]
                  : list[selectedIndex]}
              </div>
              <Box
                data-testid="footer-box"
                style={
                  footerToBottom
                    ? {
                        position: 'absolute',
                        bottom: '0',
                        left: '0',
                        right: '0',
                        margin: 'auto',
                        maxWidth: '676px',
                        paddingLeft: '5px',
                      }
                    : {}
                }
              >
                {!showNext && (
                  <StackItem
                    css={
                      {
                        padding: '$none $five',
                        flexDirection: 'row',
                        marginTop: '$oneAndHalf',
                        maxWidth: '800px',
                      } as GDSStyleObject
                    }
                  >
                    {[
                      ...Array(
                        formName === FORM_API_TYPE.DENTAL_CLAIM
                          ? showNext
                            ? instructionsList.length
                            : sessionStorage.getItem('otherCoverage') === 'NO'
                            ? noOcCompList.length
                            : list.length
                          : list.length,
                      ),
                    ].map((i: any, index: any, arr: any) => (
                      <Box
                        key={i}
                        css={{
                          backgroundColor:
                            index >= selectedIndex + 1 ? '#D6D6D6' : '#0074C9',
                          height: '4px',
                          borderRadius: '$medium',
                          marginRight: index < arr.length - 1 ? '10px' : '',
                        }}
                      />
                    ))}
                  </StackItem>
                )}
                {showNext ? (
                  <Box
                    css={
                      {
                        display: 'flex',
                        flexDirection: 'row',
                        padding: '$twoAndHalf',
                        justifyContent: 'end',
                        maxWidth: '800px',
                      } as GDSStyleObject
                    }
                  >
                    <StackItem
                      css={
                        {
                          padding: '$five $none',
                        } as GDSStyleObject
                      }
                    >
                      <TextAction
                        onClick={closeInstructions}
                        icon={rightArrowIcon as string}
                      >
                        <span
                          style={{
                            position: 'relative',
                            right: '95px',
                            fontSize: 'x-large',
                            height: '28px',
                          }}
                        >
                          NEXT
                        </span>
                      </TextAction>
                    </StackItem>
                  </Box>
                ) : (
                  <Box
                    css={
                      {
                        display: 'grid',
                        padding: '$twoAndHalf',
                        justifyContent: 'center',
                        '@mobile': { gridTemplateColumns: '22% 22% 22%' },
                        '@laptop': { gridTemplateColumns: '26% 29% 25%' },
                        '@desktop': { gridTemplateColumns: '26% 29% 25%' },
                        '@tablet': { gridTemplateColumns: '26% 29% 25%' },
                        '@mobileLandscape': {
                          gridTemplateColumns: '26% 29% 25%',
                        },
                      } as GDSStyleObject
                    }
                  >
                    <StackItem
                      css={
                        {
                          alignItems: 'start',
                        } as GDSStyleObject
                      }
                    >
                      <img
                        data-testid="previous-btn"
                        onClick={
                          showNext === undefined
                            ? selectedIndex + 1 > 1
                              ? goPrevious
                              : () => {}
                            : selectedIndex + 1 > 1
                            ? goPrevious
                            : closeInstructions
                        }
                        style={{
                          cursor:
                            showNext === undefined
                              ? selectedIndex + 1 > 1
                                ? 'pointer'
                                : ''
                              : 'pointer',
                        }}
                        src={
                          showNext === undefined
                            ? selectedIndex + 1 > 1
                              ? (leftArrowIcon as string)
                              : (leftArrowDisabledIcon as string)
                            : (leftArrowIcon as string)
                        }
                        alt="left arrow icon"
                        width="24px"
                        aria-hidden="true"
                      />
                    </StackItem>
                    <StackItem
                      css={
                        {
                          alignItems: 'center',
                        } as GDSStyleObject
                      }
                    >
                      <UtilityText>
                        {selectedIndex + 1} of{' '}
                        {formName === FORM_API_TYPE.DENTAL_CLAIM
                          ? showNext
                            ? instructionsList.length
                            : sessionStorage.getItem('otherCoverage') === 'NO'
                            ? noOcCompList.length
                            : list.length
                          : list.length}
                      </UtilityText>
                    </StackItem>
                    <StackItem
                      css={
                        {
                          alignItems: 'end',
                        } as GDSStyleObject
                      }
                    >
                      {selectedIndex + 1 ===
                      (formName === FORM_API_TYPE.DENTAL_CLAIM
                        ? showNext
                          ? instructionsList.length
                          : sessionStorage.getItem('otherCoverage') === 'NO'
                          ? noOcCompList.length
                          : list.length
                        : list.length) ? (
                        <UtilityText
                          css={{
                            color: '#0074C9',
                            cursor: 'pointer',
                            fontWeight: 'bold',
                          }}
                          onClick={handleFormSubmit}
                        >
                          Submit
                        </UtilityText>
                      ) : (
                        <img
                          data-testid="gonextimg"
                          onClick={goNext}
                          style={{ cursor: 'pointer' }}
                          aria-hidden="true"
                          src={rightArrowIcon as string}
                          alt="right arrow icon"
                          width="24px"
                        />
                      )}
                    </StackItem>
                  </Box>
                )}
              </Box>
            </>
          )}
        </>
      )}
    </div>
  );
}
